export default {
  init() {
    // JavaScript to be fired on the home page
    this.specialsSlider();
  },
  specialsSlider() {
    $(document).ready(function(){
      let specials = ".swiper-container--specials";
      if ($(specials).length) {
        var swiper = new Swiper(specials, { // eslint-disable-line
          slidesPerView: 2,
          spaceBetween: 11,
          speed: 600,
          pagination: {
            el: '.swiper-pagination',
            type: 'custom',
            renderCustom: function (swiper, current, total) {
              let html = "";
              for (let i = 0; i <= total; i++) {
                if (i === current-1) {
                  html += "<span class='p_item p_item-active'></span>"
                } else {
                  html += "<span class='p_item'></span>"
                }
              }
              return html;
            }
          },
          // centeredSlides: true,
          loop: true,
          // loop: false,
          autoplay: {
            delay: 3500,
          },
          navigation: {
            prevEl: '.specials-carousel__button--prev',
            nextEl: '.specials-carousel__button--next',
          },
          breakpoints: {
            320: {
              slidesPerView: 1,
            },
            480: {
              slidesPerView: 1,
              autoplay: {
                delay: 3000,
              },
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 2,
            },
          },
        });
      }
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
